import React from 'react';
import { MAP_HEIGHT } from '@/experiences/sales-portal/components/map/constants';
import { Skeleton } from '@usepepper/sprout-kit-ui';
import { useTheme } from '@/contexts/theme-context';

export const MapSkeleton: React.FC = () => {
  const theme = useTheme();

  return (
    <Skeleton
      borderRadius={theme.sk.radii.radiusLarge}
      height={MAP_HEIGHT}
      variant="rect"
      width="100%"
    />
  );
};
